import { useQuery } from '@tanstack/react-query';
import { useStore } from 'zustand';

import { getUsers } from '../api';
import { usersQueryKeys } from '../data';
import { usersStore } from '../store';

export const useUsers = () => {
  const { page, rowsPerPage, searchString } = useStore(usersStore);

  const queryParams = {
    page,
    rowsPerPage,
    searchString,
  };

  const usersQuery = useQuery({
    queryKey: [...usersQueryKeys.getUsers, queryParams],
    queryFn: getUsers.bind(null, queryParams),
    staleTime: 5_000,
  });

  return usersQuery;
};
